import { Link, useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'
import AuthShell, { Field, SubmitButton } from '@/components/AuthShell'
import { t } from '@/lib/i18n'

// 浏览器报的 IANA 时区（如 "Asia/Shanghai"）。时区决定「今天」的边界，进而决定
// 连续天数与热力图，所以注册时就要落对，不能指望用户事后自己去设置里找。
// 拿不到就交空串，后端退回 UTC。
function detectTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || ''
  } catch {
    return ''
  }
}

export default function Register() {
  const form = useForm({
    email_address: '',
    password: '',
    password_confirmation: '',
    timezone: detectTimezone(),
  })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post('/registration')
  }

  return (
    <AuthShell
      title={t('auth.register.title')}
      subtitle={t('auth.register.subtitle')}
      footer={
        <>
          {t('auth.register.have_account')}<Link href="/session/new" className="text-brand font-semibold">{t('auth.login.title')}</Link>
        </>
      }
    >
      <form onSubmit={submit} className="grid gap-4">
        <Field
          label={t('auth.email')}
          type="email"
          autoComplete="username"
          autoFocus
          required
          value={form.data.email_address}
          error={form.errors.email_address}
          onChange={(e) => form.setData('email_address', e.target.value)}
        />
        <Field
          label={t('auth.password')}
          type="password"
          autoComplete="new-password"
          required
          maxLength={72}
          placeholder={t('auth.min_length')}
          value={form.data.password}
          error={form.errors.password}
          onChange={(e) => form.setData('password', e.target.value)}
        />
        <Field
          label={t('auth.password_confirmation')}
          type="password"
          autoComplete="new-password"
          required
          maxLength={72}
          value={form.data.password_confirmation}
          error={form.errors.password_confirmation}
          onChange={(e) => form.setData('password_confirmation', e.target.value)}
        />
        <SubmitButton disabled={form.processing}>{form.processing ? t('auth.register.submitting') : t('auth.register.submit')}</SubmitButton>
      </form>
    </AuthShell>
  )
}
